import { render } from "./PowerDetailsModal.vue?vue&type=template&id=43bb6a19&scoped=true"
import script from "./PowerDetailsModal.vue?vue&type=script&lang=js"
export * from "./PowerDetailsModal.vue?vue&type=script&lang=js"

import "./PowerDetailsModal.vue?vue&type=style&index=0&id=43bb6a19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bb6a19"]])

export default __exports__